// extracted by mini-css-extract-plugin
module.exports = {"navigation-button":"item_navigation-button__s2grK","swiper":"item_swiper__niB8Z","news-item-text":"item_news-item-text__tKYST"};